module.exports = __webpack_public_path__ + "img/arrow-u-left-top.cf556e3a.svg";